import {UntypedFormControl} from '@angular/forms';

export const accepted = (): any => {
  return (control: UntypedFormControl): any => {
    return !!control.value ? null : {'accepted': true};
  };
};

export const noMissing = (): any => {
  return (control: UntypedFormControl): any => {
    if (!control.value) {
      return null;
    }
    const nullIdx = Object.values(control.value).findIndex(v => !v);
    return nullIdx >= 0 ? {'no-missing': true} : null;
  };
}
